import { HttpError } from '@euler/lib/request/HttpError';

/** Someone changed the dashboard since this client read it. */
export function isBiRevisionConflict(error: unknown): boolean {
  return (
    error instanceof HttpError &&
    error.subCode === 'bi_dashboard_revision_conflict'
  );
}

/** The server's catalogued sentence, or `fallback` for anything else. */
export function biErrorMessage(error: unknown, fallback: string): string {
  return error instanceof HttpError && error.code && error.message
    ? error.message
    : fallback;
}
